import { firebaseDb } from "../firebase";

import { LOAD_PREMIUM_SUCCESS } from "./action-types";

export function userSignedIn(user) {
  return dispatch => {
    const premiumRef = firebaseDb.ref(`/user/${user.uid}/premium`);
    premiumRef.on("value", snapshot => {
      dispatch(loadPremiumSuccess(snapshot.val()));
    });
  };
}

export function loadPremiumSuccess(premium) {
  return {
    type: LOAD_PREMIUM_SUCCESS,
    payload: premium
  };
}



/** WEBPACK FOOTER **
 ** ./src/core/premium/actions.js
 **/